import { render, staticRenderFns } from "./search-reviewer.dialog.vue?vue&type=template&id=a52140ea&scoped=true"
import script from "./search-reviewer.dialog.vue?vue&type=script&lang=js"
export * from "./search-reviewer.dialog.vue?vue&type=script&lang=js"
import style0 from "./search-reviewer.dialog.vue?vue&type=style&index=0&id=a52140ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52140ea",
  null
  
)

export default component.exports